export default "__VITE_ASSET__DH_os_m$__"